import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref, onMounted, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
    icon: {}
  },
  setup(__props: any) {

const props = __props
const svgContent = ref('')

// Simple in-memory cache shared by all component instances
// key: icon name -> value: string (svg) OR Promise<string> (in-flight)
const iconCache = (globalThis as any).__ICON_SVG_CACHE__ || new Map<string, string | Promise<string>>()
;(globalThis as any).__ICON_SVG_CACHE__ = iconCache

async function loadIcon(name: string) {
  if (!name) {
    svgContent.value = ''
    return
  }

  // Hit: resolved SVG already cached
  const cached = iconCache.get(name)
  if (typeof cached === 'string') {
    svgContent.value = cached
    return
  }

  // Hit: request already in-flight — await it
  if (cached instanceof Promise) {
    svgContent.value = await cached
    return
  }

  // Miss: start fetch, cache the Promise immediately to dedupe
  const url = require(`@/assets/img/${name}.svg`)
  const p = fetch(url).then(r => {
    if (!r.ok) throw new Error(`Failed to load ${name}.svg: ${r.status}`)
    return r.text()
  }).then(txt => {
    // Replace the Promise with the resolved string for faster future hits
    iconCache.set(name, txt)
    return txt
  }).catch(err => {
    // On error, remove the broken promise so future attempts can retry
    iconCache.delete(name)
    console.error(err)
    return ''
  })

  iconCache.set(name, p) // cache in-flight promise
  svgContent.value = await p
}

onMounted(() => loadIcon(props.icon))
watch(() => props.icon, (n) => loadIcon(n), { immediate: false })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", { innerHTML: svgContent.value }, null, 8, _hoisted_1))
}
}

})